/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M256.307 240.18c-34.465 0-62.398-27.932-62.398-62.397 0-34.466 27.933-62.398 62.398-62.398s62.398 27.932 62.398 62.398c0 34.465-27.933 62.398-62.398 62.398zm0-239.116c-93.879 0-170.27 76.392-170.27 170.27 0 90.36 154.783 325.816 161.4 335.783 1.943 2.985 5.294 4.787 8.87 4.787 3.576 0 6.899-1.802 8.87-4.787 6.589-9.967 161.4-245.424 161.4-335.782 0-93.879-76.392-170.271-170.27-170.271z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconLocation = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconLocation.defaultProps = {
  theme,
};
IconLocation.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconLocation.displayName = 'IconLocation';
export { IconLocation };
